import {IApiSingleResponseBase} from '../../types';
import {palipaliAPI} from '../provider/palipaliAPI';
import {RestQueryParams} from '../base/queryParams';
import {Observable} from 'rxjs';

export function getStreamMediaObjectAPI(authToken: string, mediaObjectId: string): Observable<IApiSingleResponseBase<any>> {
    return palipaliAPI.get(`api/media_objects/${mediaObjectId}/stream`, new RestQueryParams(), {
        Accept: 'application/ld+json',
        'Content-type': 'application/pdf',
        Authorization: `Bearer ${authToken}`,
    });
}
